import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BreezeService } from '../../../shared/services/breeze.service';
import { ErrorService } from '../../../shared/services/error.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class ResetPasswordComponent {
  hide = true;
  errorMessage: any;

  constructor(
    private breezeService: BreezeService,
    private errorService: ErrorService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.errorService.getErrorListener().subscribe((errorMessage) => {
      this.errorMessage = errorMessage;
    });
  }

  form: FormGroup = new FormGroup({
    newPassword: new FormControl('', [Validators.required]),
    confirmNewPassword: new FormControl('', [Validators.required]),
  });

  onResetPassword() {
    this.breezeService.resetPassword(this.form.value);
  }
}
